'use client';

import Image from 'next/image';
import { useLightboxActions } from './LightboxContext';
import Button from '@commons/Button';
import { Dots } from '@icons';
import { usePaginator } from '@commons/Paginator/PaginatorContext';
import useDictionary from '@modules/Dictionary/useDictionary';

export default function LightBoxItem({ image, index = 0, isOptionsButton = false }) {
  const { openLightbox } = useLightboxActions();
  const { setIndex } = usePaginator();
  const { dictionary } = useDictionary();

  const openLightboxWithIndex = () => {
    openLightbox();
    setIndex(index);
  };

  return (
    <li
      className={`Lightbox__item ${isOptionsButton ? 'Lightbox__item--options' : ''}`}
      onClick={openLightboxWithIndex}
    >
      {isOptionsButton ? (
        <Button
          className="Carousel__item-options"
          priority="tertiary"
          size="auto"
          href="#"
          link={null}
          icon={null}
          type="button"
        >
          <Dots />
        </Button>
      ) : (
        <Image
          src={image.url}
          alt={image.alt || dictionary?.image?.heroAlt || 'Hero image'}
          width={150}
          height={150}
          sizes="75px"
          quality={75}
        />
      )}
    </li>
  );
}
